import $ from 'jquery';
import {ensureLoggedIn, UserInfo} from "core/auth";
import {Notifier} from "core/widgets/notifier";
import {siteUrl} from "core/utils/url";
import * as langUtils from "../../../../core/utils/lang";

export const TYPE_REVIEW_LIKE = 'review_like';
export const TYPE_COMMENT_LIKE = 'comment_like';
export const TYPE_SALE_LIKE = 'sale_like';

export class Likers {

	visible = ko.observable(false);
	loading = ko.observable(false);
	likers = ko.observableArray([]);
	likesCount = ko.observable(0);
	myLike = ko.observable(false);
	type = null;

	constructor(reviewId, likesCount, myLike, type = TYPE_REVIEW_LIKE) {
		this.reviewId = reviewId;
		this.likesCount(+likesCount);
		this.myLike(!!myLike);

		this.likesCountUsersText = ko.pureComputed(() => {
			return langUtils.pluralize(this.likesCount(), '{n} пользователю|{n} пользователям|{n} пользователям', 'n');
		});

		switch(type) {
			case TYPE_REVIEW_LIKE:
				this._saveUrl = '/reviews/save_like';
				this._getLikersUrl = '/reviews/get_likers_ajax';
				break;
			case TYPE_COMMENT_LIKE:
                this._saveUrl = '/reviews/save_comment_like';
                this._getLikersUrl = '/reviews/get_comment_likers_ajax';
				break;
			case TYPE_SALE_LIKE:
				this._saveUrl = '/blog/likes_save';
				this._getLikersUrl = '/blog/get_likers';
				break;
		}
	}

	show() {
		this._load().done(() => {
			this.visible(this.likesCount() > 0)
		});
	}

	hide() {
		this.visible(false);
	}

	toggleMyLike(data, e) {
		e.stopPropagation();
		ensureLoggedIn(() => {
			$.post(siteUrl(this._saveUrl), {id: this.reviewId}, null, 'json')
				.fail(Notifier.errorXHR)
				.done(response => {
					if (response && response.success) {
						this.likesCount(+response.likes);
						this.myLike((response.myAction && response.myAction == 'up')
							|| (response.action && response.action == 'up'));
					}
					else {
						Notifier.error();
					}
				});
		});
	}

	_load() {
		this.loading(true);
		return $.get(siteUrl(this._getLikersUrl), {id: this.reviewId}, null, 'json')
			.done(response => {
				this.likesCount(+response.total);
				this.likers(response.likers);
				this.loading(false);
			});
	}
}


// WEBPACK FOOTER //
// ./modules/reviews/common/model/likers.js